export default __webpack_public_path__ + "static/media/Khanjar of the Faceless Man.62f2be91.jpg";